import { hasWindow } from './hasWindow';
/**
 * Find the actual color value from a css custom property (variable).
 *
 * Note: This doesn't support dynamic updates to the brand, ensure
 * that the brand variables are set before using this.
 *
 * @param variable css variable to investigate (from the brand)
 * @returns color value or the default value
 */
export function findColorFromCSSVariable(variable) {
    const token = extractTokenFromCSSVariable(variable);
    const defaultValue = extractDefaultValueFromCSSVariable(variable);
    /**
     * Check the currently applied CSS properties for a matching value.
     * Since the getComputedStyle returns *computed values* which might
     * contain e.g., spaces, we need to trim the value.
     *
     * TODO: The getComputedStyle solution doesn't work for SSR purposes,
     * figure out an alternative way to get the brand value (a shared context could work?).
     */
    const currentValue = hasWindow() && token && getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    // TODO: The types need improving here
    return currentValue || defaultValue;
}
export function extractTokenFromCSSVariable(variable) {
    const [token] = variable.match(/--.*(?=,)|--.*(?=\))/) || [];
    return token;
}
export function extractDefaultValueFromCSSVariable(variable) {
    const [token] = variable.match(/[^, ]*(?=\))/) || [];
    return token;
}
